const api = {
  sendCustomerEmail(emailTransactionId) {
    return `/email/case/${emailTransactionId}/send-customer`;
  },
  sendCustomerServiceEmail(emailTransactionId) {
    return `/email/case/${emailTransactionId}/send-customer-service`;
  },
  getCustomerServiceEmail(controlNumber) {
    return `/email/${controlNumber}/customer-service`;
  },
  startEmailTransaction() {
    return `/email/case/start-transaction`;
  },
  retrieveSettings(emailTransactionId) {
    return `/email/case/${emailTransactionId}/settings`;
  },
  emailMessage(emailTransactionId) {
    return `/email/case/${emailTransactionId}/message`;
  },
  uploadAttachment(emailTransactionId, fileName, contentType) {
    return `/email/case/${emailTransactionId}/upload-attachment/${fileName}?contentType=${contentType}`;
  },
  includeAttachment(emailTransactionId, fileName) {
    return `/email/case/${emailTransactionId}/include-attachment/${fileName}`;
  },
  sendEmail(emailTransactionId) {
    return `/email/case/${emailTransactionId}/send`;
  }
};

export default api;